import React, { useState } from "react";
import Routes from "./Routes";
import { AuthProvider } from './provider/Auth'
import { ThemeProvider } from './provider/Theme'
import { BookedProvider } from './provider/Booked'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from './components/AppBar';

import { AppointmentProvider } from './provider/Times'

const useStyles = makeStyles(theme => ({
}))

function App () {
  const classes = useStyles();

  return <div className="App">
    <ThemeProvider>
      <AuthProvider>
        <AppointmentProvider>
          <BookedProvider>
            <AppBar />
            <Routes/>
          </BookedProvider>
        </AppointmentProvider>
      </AuthProvider>
    </ThemeProvider>
</div>
}

export default App;